export const ANY_ENTITY = '0xFFfFfFffFFfffFFfFFfFFFFFffFFFffffFfFFFfF';
// Check address equality without checksums
export function addressesEqual(first, second) {
    first = first && first.toLowerCase();
    second = second && second.toLowerCase();
    return first === second;
}
// "Safer" version of [].includes() for addresses
export function includesAddress(arr, address) {
    return arr.some((a) => addressesEqual(a, address));
}
//# sourceMappingURL=address.js.map